"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eventTrigger = void 0;
function eventTrigger(el, eventName, detail) {
    var event;
    if (window['CustomEvent'] && typeof window['CustomEvent'] === 'function') {
        event = new CustomEvent(eventName, { detail: detail });
    }
    else {
        event = document.createEvent('CustomEvent');
        event.initCustomEvent(eventName, true, true, detail);
    }
    el.dispatchEvent(event);
    return event;
}
exports.eventTrigger = eventTrigger;
//# sourceMappingURL=event-trigger.js.map